import { Alert, Button, Card, Form, Input } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import loginService from "../../services/loginService";
import "./ForgotPasswordForm.css";
import MainLanding from "../../img/main-landing.png";

const ForgotPasswordForm = () => {
  const history = useHistory();

  const [login, setLogin] = useState<string>();
  const [recoveryFailed, setActionFailed] = useState<boolean>(false);
  const [apiCallInProgess, setApiCallInProgress] = useState<boolean>(false);

  const handleSubmit = async (event: React.FormEvent) => {
    setApiCallInProgress(true);
    const recoverResult = await loginService.RecoverPassword(login!);
    // show that u can check .length if youre not sure what does the empty array means
    // is null or empty on array equivalent
    setApiCallInProgress(false);
    const recoverySuccess = recoverResult.status === 200;

    if (!recoverySuccess && recoverResult.statusText?.length > 0) {
      setActionFailed(true);
      return;
    }

    if (recoverySuccess) {
      setActionFailed(false);
      history.push("/forgotpasswordconfirm");
    } else {
      setActionFailed(true);
    }
  };

  return (
    <>
      <div className="landing-page">
        <img src={MainLanding} className="page-image" alt="" />
      </div>
      <div className="page-card">
        <Card className="page-card-element">
          <h1 className="recover-card-title">Recover your password</h1>
          <span>
            Enter your email and we'll send you a link to get back into your
            account.
          </span>
          <Form
            name="basic"
            className="recover-card-form"
            onChange={(e) => setActionFailed(false)}
            onFinish={(e) => handleSubmit(e)}
            layout="vertical"
          >
            <Form.Item
              className="page-card-form-item"
              label="Email address:"
              name="login"
              rules={[
                {
                  required: true,
                  message: "Please provide your Email address!",
                },
              ]}
            >
              <Input value={login} onChange={(e) => setLogin(e.target.value)} />
            </Form.Item>

            <Form.Item
              className={
                !recoveryFailed ? "item-hidden" : "page-card-form-item"
              }
            >
              {recoveryFailed ? (
                <Alert message="Recovery Failed!" type="error" />
              ) : null}
            </Form.Item>

            <Form.Item className="page-card-form-item">
              <Button
                className="page-card-link"
                type="link"
                onClick={() => history.push("/register")}
              >
                Create new account
              </Button>
            </Form.Item>
            <Form.Item className="page-card-form-item page-card-form-item-register">
              <Button
                className="page-card-link"
                type="link"
                onClick={() => history.push("/login")}
              >
                Back to Login
              </Button>
            </Form.Item>

            <Form.Item className="page-card-form-item recover-card-form-button">
              <Button
                className="page-card-button"
                type="primary"
                htmlType="submit"
                loading={apiCallInProgess}
              >
                {apiCallInProgess ? "" : "Recover"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </>
  );
};

ForgotPasswordForm.displayName = "ForgotPasswordForm";

export default ForgotPasswordForm;
